module.exports = __webpack_public_path__ + "images/home/index/values-assign-screenshot-b0072a70f9f7d35a189ab6f32c96b1b4.png";